/*
 * All tags, analytics, trackers related code should be under this namespace
 */
import { gtm } from './gtm';

export const tags = {
  gtm,
};
